import { areArrayEquals, isArray } from '../../../utils'

import { type Capability, createIndexedCapabilities, selectAuthenticatedCapabilities } from '../../../domain'

import { useAppState } from '../State'
import { getRouteCapabilities } from './Config'
import type { AbsoluteRoutePath } from './Domain'

export const useHasCapabilities = (): ((requiredCapabilitiesAlternativesOrRoute: readonly Capability[] | AbsoluteRoutePath) => boolean) => {
    const [hasCapabilities] = useAppState(
        (s) => [createIndexedCapabilities(s), selectAuthenticatedCapabilities(s) ?? []],
        ([, a]: [unknown, readonly Capability[]], [, b]: [unknown, readonly Capability[]]) => areArrayEquals(a, b, { sort: false })
    )
    return (alternativesOrRoute) => {
        const alternatives = isArray(alternativesOrRoute)
            ? [alternativesOrRoute]
            : getRouteCapabilities(alternativesOrRoute).map((capabilities) => capabilities.required)
        return alternatives.some(hasCapabilities)
    }
}
